import React, { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { observer } from 'mobx-react-lite';

import { Content, SearchTechnician } from 'components';
import { Technician } from 'types';

export const TechnicianSearchPage: FC = observer(() => {
  const navigate = useNavigate();

  return (
    <Content.$ dataTestId="technician-search-page" hasContainer>
      <Helmet>
        <title>Technician Search</title>
      </Helmet>
      <SearchTechnician.$
        syncParamsToUrl
        actions={[
          {
            title: 'View / Edit',
            action: (record: Technician) => {
              navigate(`/technician/edit/${record.ID}/details`);
            },
          },
        ]}
      />
    </Content.$>
  );
});
